import { inject, injectable } from "@launchtray/tsyringe-async";
import { IPushController } from "./IPushController";
import { IPushModel } from "../model/IPushModel";
import { IPlayerModel } from "../../../common/models/IPlayerModel";

@injectable()
export class PushController implements IPushController {
    private readonly pushModel: IPushModel;
    private readonly playerModel: IPlayerModel;

    constructor(@inject("IPushModel") pushModel: IPushModel, @inject("IPlayerModel") playerModel: IPlayerModel) {
        this.pushModel = pushModel;
        this.playerModel = playerModel;
    }

    public async allowPushNotification(isNotificationDialogAvailable: boolean, result?: PushSubscription, timeout?: boolean): Promise<void> {
        const playerDto = await this.pushModel.allowPushNotification(isNotificationDialogAvailable, result, timeout);
        const rewardInCoins = playerDto.coinsBalance - this.playerModel.coins.value;
        this.playerModel.addCoins(rewardInCoins);
    }
}
